import { getPocketBase } from '../pocketbase.js';

export async function fetchPlayerStats({ seasonCode } = {}, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const opts = { sort: 'player_name' };
  if (seasonCode) opts.filter = `season_code="${seasonCode}"`;
  return pb.collection('player_stats').getFullList(opts);
}

export async function savePlayerStats({ accessKey, seasonCode, players }, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const existing = await pb.collection('player_stats').getFullList({
    filter: `access_key="${accessKey}" && season_code="${seasonCode}"`,
  });
  await Promise.all(
    existing.map((rec) => pb.collection('player_stats').delete(rec.id)),
  );
  await Promise.all(
    players.map((p) =>
      pb.collection('player_stats').create({
        access_key: accessKey,
        season_code: seasonCode,
        player_name: p.name,
        team_name: p.team,
        role: p.role,
        roles: p.roles,
        quotation: p.quot || 0,
        fm_score: p.fm_score || 0,
        matches: p.matches || 0,
        goals: p.goals || 0,
        assists: p.assists || 0,
        yellow_cards: p.yellow_cards || 0,
        red_cards: p.red_cards || 0,
      }),
    ),
  );
  return { success: true, inserted: players.length, season: seasonCode };
}
